import { useEffect, useState } from 'react';
import socialService from '@services/socialService';
import type { FormatRule } from '@/types/social';

/** Regras dos formatos (cache do serviço). */
export const useFormatRules = (): FormatRule[] => {
  const [rules, setRules] = useState<FormatRule[]>([]);
  useEffect(() => {
    let alive = true;
    socialService
      .formats()
      .then((f) => alive && setRules(f.formats ?? []))
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);
  return rules;
};
